import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

const IMG = "https://images.unsplash.com/photo-1619852182277-79aa23f82c8e?w=1200&q=80";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="grain relative hidden overflow-hidden bg-[#0B1A33] lg:block">
        <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="grid-texture absolute inset-0" />
        <div className="relative flex h-full flex-col justify-between p-12 text-white">
          <Logo className="h-16" />
          <div>
            <h2 className="text-4xl font-extrabold leading-tight">Explore to <span className="text-[#3CC34A]">Excel</span>.</h2>
            <p className="mt-4 max-w-md text-slate-300">Verified tutors, live video classes and a transparent credit wallet — all in one place.</p>
          </div>
          <p className="text-xs text-slate-500">© FosterApp™</p>
        </div>
      </div>
      <div className="flex items-center justify-center bg-[#F4F7FA] px-4 py-12 sm:px-8">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden"><Link to="/" className="inline-block rounded-lg bg-[#0B1A33] p-1"><img src="/logo.jpeg" alt="FosterApp" className="h-12" /></Link></div>
          <h1 className="rise text-3xl font-extrabold text-[#0B1A33]" data-testid="auth-title">{title}</h1>
          {subtitle && <p className="rise d1 mt-2 text-slate-500">{subtitle}</p>}
          <div className="rise d2 mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
